import { LookupValue } from "./lookup-value";

export class EmploymentDetails {
  employerName = '';
  employerCountry:LookupValue | null = null ;
  position = '';
  start = '';
  end = '';
  responsibilities = '';
}